import "../OrderMessagesFlyout/order-messages-flyout.style.scss";

import { Button as StencilButton, ButtonSize, ButtonVariant } from "@amzn/stencil-react-components/button";
import { WithFlyout } from "@amzn/stencil-react-components/flyout";
import { Row } from "@amzn/stencil-react-components/layout";
import IconNotification from "@amzn/stencil-react-icons/icons/icon-notification";
import React from "react";

import { OrderMessagesFlyout } from "../OrderMessagesFlyout/order-messages-flyout";
import { OrderMessagesIconProps } from "../OrderMessagesFlyout/order-messages-flyout.types";
import { messageStorage } from "@/services/message-storage/message-storage";

export const OrderMessagesIcon: React.FC<OrderMessagesIconProps> = ({
  hasOrderSupport,
  lastCommentOn,
  lastCommentBy,
  orderId,
  currentUser,
  title,
  orderReference,
  orderTaxId,
}) => {
  const lastCommentTimestamp = typeof lastCommentOn === "string" ? lastCommentOn : lastCommentOn?.toISOString();

  const [showBadge, setShowBadge] = React.useState(() => {
    if (!hasOrderSupport || !lastCommentTimestamp || !orderId) return false;
    if (lastCommentBy === currentUser) return false;
    const lastSeen = messageStorage.getLastSeenTimestamp(orderId);
    return lastSeen !== lastCommentTimestamp;
  });

  const handleOpen = (open: () => void) => {
    if (orderId && lastCommentTimestamp) {
      messageStorage.setLastSeenTimestamp(orderId, lastCommentTimestamp);
    }
    setShowBadge(false);
    open();
  };

  if (!hasOrderSupport) return null;

  return (
    <Row gridGap={8}>
      <WithFlyout
        renderFlyout={({ close }) => (
          <OrderMessagesFlyout
            onClose={close}
            isSupportRequested={hasOrderSupport}
            title={title}
            orderReference={orderReference}
            orderTaxId={orderTaxId}
          />
        )}
      >
        {({ open }) => (
          <StencilButton
            data-testid="messages-button"
            aria-disabled={false}
            icon={
              <div className="icon-container">
                <IconNotification title="Notifications" />
                {showBadge && (
                  <span
                    data-testid="notification-dot"
                    className="notification-dot"
                  />
                )}
              </div>
            }
            size={ButtonSize.Small}
            variant={ButtonVariant.Tertiary}
            onClick={() => handleOpen(open)}
          />
        )}
      </WithFlyout>
    </Row>
  );
};
